import React from 'react';

const HelpText = ({ message }) => {
  // standard help text component
  return (
    <p className="sb-form-helptext sb-flex">
      <span className="sb-message-icon"></span> {message}
    </p>
  );
};

export default HelpText;
